<template>
  <v-container>
    <div>
      <p v-for="file in files" :key="file.fileId">
        <a :href="endpoint+file.fileId">{{ file.givenName }}</a>
      </p>
    </div>
    <v-card
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      :class="{ 'grey lighten-2': dragover }"
      min-height="200"
      width="100%"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon
            @click="() => $refs.uploader.click()"
            :class="[dragover ? 'mt-2, mb-6' : 'mt-5']"
            size="60"
          >mdi-cloud-upload</v-icon>

          <!-- Hidden file input trigger with js -->
          <input
            ref="uploader"
            class="d-none"
            multiple
            type="file"
            @change="(e) => onFileClickChanged(e)"
          >

          <p>Drop your file(s) here, or click the cloud icon to select them.</p>
        </v-row>

        <v-virtual-scroll
          v-if="uploadedFiles.length > 0"
          :items="uploadedFiles"
          height="150"
          item-height="50"
        >
          <template v-slot:default="{ item }">
            <v-list-item :key="item.name">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <span class="ml-3 text--secondary">
                    {{ item.size }} bytes</span
                  >
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn @click="() => removeFile(item.name)" icon>
                  <v-icon> mdi-close-circle </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'Upload',
  props: {
    files: {
      type: Array,
    },
  },
  data: () => ({
    dragover: false,
    isUploading: false,
    uploadedFiles: [],
  }),

  computed: {
    endpoint() {
      return `/api/additional_information/${this.$store.state.contractId}/${this.$store.state.accessKey}/download/`;
    },
  },

  methods: {
    onFileClickChanged(e) {
      if (e.target.files.length >= 1) {
        this.addFile(Object.keys(e.target.files).map((key) => e.target.files[key]));
      }
    },

    onDrop(e) {
      this.dragover = false;
      if (e.dataTransfer.files.length >= 1) {
        this.addFile(Object.keys(e.dataTransfer.files).map((key) => e.dataTransfer.files[key]));
      }
    },

    addFile(files) {
      files.forEach((file) => {
        /*
        if (file.type !== 'text/csv') {
          // alert(file.name + ' Must be CSV format');
          return;
        }
        */
        this.uploadedFiles.push(file);
      });
      this.$emit('input', this.uploadedFiles);
    },

    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);

      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1);

      // if manual file upload is not empty clear
      if (this.$refs.uploader.value) this.$refs.uploader.value = '';
    },
  },
};
</script>
